import { ICianMFUIElement } from '@cian/mf-registry/browser';
import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import { useEffect, useRef, useState } from 'react';
import { AD_BANNER_MF_NAME } from 'shared/constants/microfrontends';
import { useApplicationContext } from 'shared/containers/ApplicationContext';

export function useAdBannerMicrofrontend() {
  const { config } = useApplicationContext();
  const microfrontendRef = useRef<ICianMFUIElement | null>(null);
  const manifest = config.get<IMicrofrontendManifest>(`microfrontendManifests.${AD_BANNER_MF_NAME}`);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setIsReady(true);
    }, 0);

    return () => clearTimeout(timeoutId);
  }, []);

  return { manifest, microfrontendRef, isReady };
}
